// components/Thumbnails.js
import React from "react";

const Thumbnails = ({ images, currentSlide, onThumbClick }) => {
  return (
    <div
      className="minimove-thumbnails-row thumbnails-grid"
      style={{ "--thumb-count": images.length }}
    >
      {images.map((item, idx) => (
        <div
          key={idx}
          onClick={() => onThumbClick(idx)}
          className={`minimove-thumbnail-wrapper ${
            idx === currentSlide ? "active" : ""
          }`}
        >
          <img src={item.url} alt="" className="minimove-thumbnail-image" />
        </div>
      ))}
    </div>
  );
};

export default Thumbnails;
